module.exports = __webpack_public_path__ + "static/media/20.e9d94fa1.jpg";